export const namespaced = true;

export const state = {
    stells: [],
    types: [],
    stell: {},
    loading: false,
}

export const mutations = {
    FETCH_MATERIALS(state, stells) {
        state.stells = stells;
    },
    FETCH_TYPES(state, types) {
        state.types = types;
    },
    ADD_MATERIAL(state, stell) {
        state.stells.unshift(stell);
    },
    FETCH_MATERIAL(state, stell) {
        state.stell = stell;
    },
    MATERIAL_TOGGLE_MAIN(state) {},
    MATERIAL_REMOVE(state) {},
}

export const actions = {

    async fetch({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/stells`)).data;
            commit('FETCH_MATERIALS', res.data);
            return res.data;
        } catch (error) {
            const stell = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('stell/add', stell, { root: true })
        }
    },

    async fetchMaterial({ commit, state, dispatch }, stell_id) {

        try {
            const res = (await axios.get(`/api/admin/stells/${stell_id}`)).data;
            commit('FETCH_MATERIAL', res.data);
            return res.data;
        } catch (error) {
            const stell = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('stell/add', stell, { root: true })
        }
    },

    async fetchTypes({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/stells/types`)).data;
            commit('FETCH_TYPES', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async toggleMain({ commit, dispatch }, stell_id) {
        try {
            const res = (
                await axios.patch(
                    `/api/admin/stells/${stell_id}/toggle-main`
                )
            ).data;
            commit('MATERIAL_TOGGLE_MAIN');

            dispatch('fetch');

            const notification = {
                type: "success",
                message: "Запрос выполнен успешно",
            };
            dispatch("notification/add", notification, { root: true });
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },

    async remove({ commit, dispatch }, stell_id) {
        try {
            const res = (
                await axios.delete(
                    `/api/admin/stells/${stell_id}`
                )
            ).data;
            commit('MATERIAL_REMOVE');

            dispatch('fetch');

            const notification = {
                type: "success",
                message: "Материал успешно удален",
            };
            dispatch("notification/add", notification, { root: true });
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },





}
